import React from 'react'
import Footer from '../Footer/Footer';

const Web = () => {
  return (
    <div>
      <h2> Hi I I have Collection of Website.12 </h2>
      
      {/* Footer  */}
      <section className='p-0'>
        <Footer />
      </section>
    </div>
  )
}

export default Web
